import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";
import { P3AllRTFOverrides, SectionPaddingClassName } from "../styles";

export const Statement: React.FC<{
  heading?: string | null;
  title?: string | null;
  message?: IRichTextInformation | null;
  className?: string;
  quoteTitle?: boolean | null;
}> = ({ heading, title, message, className, quoteTitle }) => {
  return (
    <section
      data-component="Statement"
      className={classNames(SectionPaddingClassName, className)}
    >
      <div className="page-grid max-width relative">
        <div
          className={classNames(
            "col-span-4 col-start-2",
            "md:col-span-6 md:col-start-3",
            "lg:col-span-8 lg:col-start-5",
            "text-center",
          )}
        >
          {heading && (
            <span
              className={classNames(
                "block",
                "font-serif",
                "font-bold",
                "text-18-125",
                "text-hyacinth",
                "mb-20px",
                "lg:mb-40px",
              )}
            >
              {heading}
            </span>
          )}
          {quoteTitle && <span className="h3">“</span>}
          {title && (
            <h2
              className={classNames(
                "h3",
                "mb-20px",
                "lg:mb-40px",
                quoteTitle && "inline",
              )}
            >
              {title}
            </h2>
          )}
          {quoteTitle && <span className="h3">”</span>}
          {message && (
            <RTF
              content={message}
              className="pt-20px lg:m-auto lg:w-4/5"
              classNameOverrides={P3AllRTFOverrides}
            />
          )}
        </div>
      </div>{" "}
    </section>
  );
};
